import React, { useState } from "react";
import { Button } from "react-bootstrap";
import CustomButton from "../../Components/Button";

import { spaceTypeImg } from "../../Constants/Images";

interface AboutBusinessType {
  changeNextStep: Function;
  skipStep: Function;
}

const AboutBusiness: React.FC<AboutBusinessType> = ({
  changeNextStep,
  skipStep,
}) => {
  const [loading, setLoading] = useState(false);

  const saveUserTypes = () => {};

  return (
    <div className="about-business-wrapper">
      <div className="row intro-step">
        <div className="col-md-6 col-sm-6 col-xs-12">
          <div className="intro-step-img">
            <img src={spaceTypeImg} alt="" />
          </div>
        </div>

        <div className="col-md-6 col-sm-6 col-xs-12">
          <div className="add-space-form-intro">
            <h2>
              Before we get started are you a venue owner or event planner?
            </h2>
            <p>
              Choose the type of account that best fits your role to begin your
              journey with us.
            </p>
          </div>
        </div>
      </div>

      <div className="navigation-btns">
        <Button className="skip-btn" onClick={() => skipStep()}>
          Skip
        </Button>

        <CustomButton
          isLoading={loading}
          title="Continue"
          onClick={() => saveUserTypes()}
        />
      </div>
    </div>
  );
};

export default AboutBusiness;
